<main-header></main-header>
<main>
    <div class="container">
        <div class="top-part">
            <div class="breadcrumb">
                <import-navigator currentStep="upload"></import-navigator>
                <div class="wrap-text">
                    <b>
                        Data sanity check
                    </b>
                </div>
            </div>
        </div>
        <div [ngClass]="{'loading':!dataLoaded, 'middle-part' :true, 'set-up':true}">
            <div class="current-status">
                <div class="left">
                    <div class="dot green"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                </div>
                <div class="divider"></div>
                <div class="right" *ngIf="blockingIssues && blockingIssues.length">
                    <div class="wrap">
                        See blocking data issues below
                    </div>
                    <div class="wrap">
                        <a [routerLink]="['/reupload']" [queryParams]="{projectId: projectId}" class="btn btn-gray btn-small">Re-upload data</a>
                    </div>
                </div>
                <div class="right" *ngIf="!blockingIssues">
                    <div class="wrap">
                        Review data issues highlighted below
                    </div>
                    <div class="wrap">
                        <button autofocus (click)="save()" [ngClass]="{'loading-small':loading, 'btn':true, 'btn-green':true, 'btn-small':true}">continue here</button><span class="text-small"> or <a [routerLink]="['/reupload']" [queryParams]="{projectId: projectId}">re-upload your data</a></span>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="blockingIssues && blockingIssues.length">
                <div class="alert" *ngFor="let issue of blockingIssues">
                    <span class="alert-text" title="{{issue.longDesc}}">
                        {{issue.shortDesc}} <help-link helpId="34"></help-link>
                    </span>
                </div>
            </ng-container>
            <ng-container *ngIf="!blockingIssues && standaloneWarnings">
                <div class="alert" *ngFor="let issue of standaloneWarnings">
                    <span class="alert-text alert-text_yellow" title="{{issue.longDesc}}">
                        {{issue.shortDesc}} <help-link helpId="35"></help-link>
                    </span>
                </div>
            </ng-container>

            <div class="table-data">
                <table>
                    <thead>
                    <tr>
                        <th *ngFor="let columnName of columnNames">
                            {{columnName}}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="small-font">
                        <td *ngFor="let count of columnUniqueValsCounts">
                            {{count}} values
                        </td>
                    </tr>
                    <tr class="small-font">
                        <ng-container *ngFor="let warns of columnWarnings">
                            <td *ngIf="!warns || !warns.length"></td>
                            <td *ngIf="warns && warns.length" class="yellow">
                                <div *ngFor="let warn of warns" title="{{warn.longDesc}}">
                                    {{warn.shortDesc}} ⓘ
                                </div>
                            </td>
                        </ng-container>
                    </tr>
                    </tbody>
                </table>
            </div>
            
        </div>
    </div>
</main>
